import { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { createIdentityAPIEndpoint, EndPoints } from "../services/AuthServices";
import { BASE_URL_STRING } from "../services/axios";

export const AuthContext = createContext();

const API_BASE_URL = BASE_URL_STRING;

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const saveToken = (token) => {
    sessionStorage.setItem("token", token);
    setIsAuthenticated(true);
  };
  const isTokenValid = (token) => {
    try {
      const decoded = jwtDecode(token);

      return Date.now() < decoded.exp * 1000;
    } catch {
      return false;
    }
  };

  const login = (accesstoken) => {
    if (!accesstoken || !isTokenValid(accesstoken)) {
      return false;
    }
    saveToken(accesstoken);
    return true;
  };

  const logout = async () => {
    try {
      await axios.post(
        `${API_BASE_URL}v1/account/logout`,
        {},
        { withCredentials: true },
      );
    } catch (error) {
      console.error("Logout error:", error);
    }

    sessionStorage.removeItem("token");

    setIsAuthenticated(false);
    setLoading(false);
  };

  const refreshAccessToken = async () => {
    try {
      const response = await createIdentityAPIEndpoint(
        EndPoints.refresh,
      ).postWithOptions({}, { withCredentials: true });

      const newAccessToken = response.data.accessToken;

      if (!newAccessToken) {
        throw new Error("No access token returned");
      }

      return saveToken(newAccessToken) ? newAccessToken : null;
    } catch (error) {
      console.error("Refresh token failed:", error);

      sessionStorage.removeItem("token");
      setIsAuthenticated(false);

      return null;
    }
  };

  useEffect(() => {
    const initializeAuth = async () => {
      const token = sessionStorage.getItem("token");

      if (token && isTokenValid(token)) {
        setIsAuthenticated(true);
        setLoading(false);
        return
      }
      if (token)
        sessionStorage.removeItem("token");
      refreshAccessToken();
      setLoading(false)
    };
    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        loading,
        refreshAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default function useAuthContext() {
  return useContext(AuthContext);
}
